import React, { useState, useRef, useEffect } from "react";
import { useGetAllMessages } from "../hooks/message";
import { addDoc, collection, doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../lib/firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import SearchIcon from "@mui/icons-material/Search";
import SendIcon from "@mui/icons-material/Send";
import EmojiPicker from "emoji-picker-react";
import PhotoIcon from "@mui/icons-material/Photo";
import MoodIcon from "@mui/icons-material/Mood";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { storage } from "../lib/firebaseConfig";
import axios from 'axios';

function InstagramDmCompo() {
  const [userInput, setUserInput] = useState("");
  const [photoFiles, setPhotoFiles] = useState([]);
  const [emoji, setEmoji] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const chatboxRef = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const domain = window.location.host;
  const { allMessages } = useGetAllMessages();
  const [selectMessage, setSelectMessage] = useState(null);
  const [isOnline, setIsOnline] = useState(false);

  useEffect(() => {
    const handleOnlineStatus = () => {
      setIsOnline(true);
      updateOnlineStatus(true);
    };

    const handleOfflineStatus = () => {
      setIsOnline(false);
      updateOnlineStatus(false);
    };

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, []);

  useEffect(() => {
    if (chatboxRef && chatboxRef.current) {
      const element = chatboxRef.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: "smooth",
      });
    }
  }, [chatboxRef, allMessages]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredMessages = allMessages.filter(
    ({ messages }) =>
      messages &&
      messages.message &&
      messages.message.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handlePhotoUpload = (event) => {
    const files = event.target.files;
    const allowedTypes = ["image/jpeg", "image/png"];

    const selectedFiles = Array.from(files).filter((file) =>
      allowedTypes.includes(file.type)
    );

    const fileObjects = selectedFiles.map((file) => ({
      file: file,
      previewURL: URL.createObjectURL(file),
    }));

    setPhotoFiles(fileObjects);
  };

  const handleEmojiSelection = (selectedEmoji) => {
    const emojiValue = selectedEmoji.emoji;
    setEmoji((prevEmoji) => prevEmoji + emojiValue);
    setUserInput((prevUserInput) => prevUserInput + emojiValue);
  };

  const handleToggleEmojiPicker = () => {
    setShowEmojiPicker((prevState) => !prevState);
  };

  const handleDeletePhoto = (index) => {
    const updatedPhotoFiles = [...photoFiles];
    updatedPhotoFiles.splice(index, 1);
    setPhotoFiles(updatedPhotoFiles);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!userInput && photoFiles.length === 0 && !emoji) return;

    if (selectMessage) {
      try {
        setIsSending(true);

        if (photoFiles.length > 0) {
          for (const photoFile of photoFiles) {
            const storageRef = ref(storage, "photos/" + photoFile.file.name);
            await uploadBytes(storageRef, photoFile.file);
            const photoURL = await getDownloadURL(storageRef);

            await addDoc(
              collection(
                db,
                "chatUsers",
                selectMessage?.messageUserId,
                "messages"
              ),
              {
                messageUserId: domain,
                message: userInput,
                photoURL: photoURL,
                timestamp: new Date(),
              }
            );

            await addDoc(collection(db, "chatUsers", domain, "messages"), {
              messageUserId: domain,
              message: userInput,
              photoURL: photoURL,
              timestamp: new Date(),
            });
          }
        } else {
          await addDoc(
            collection(
              db,
              "chatUsers",
              selectMessage?.messageUserId,
              "messages"
            ),
            {
              messageUserId: domain,
              message: userInput,
              timestamp: new Date(),
            }
          );

          await addDoc(collection(db, "chatUsers", domain, "messages"), {
            messageUserId: domain,
            message: userInput,
            timestamp: new Date(),
          });
        }

        const facebookResponse = await axios.post(`https://graph.facebook.com/v11.0/me/messages?access_token=EAATEgM1RKk0BABosedKHygwggbdNlTmoRZCZA85J93ZBubtMv7PxXrYCFzDLLBbjqxC7Ms3Rcmme3O0EqWij3zilG3J7eIUwkGgmJJBw8dhihjAywv1YhlZCQny778qwi6exxOW5ZCokRhrTKSJLpWxif2ZC9oqFYC2z4pJa8AUmw7AZATW0yZCviUAJKt6IEnzKjd7ZAedMzZBAZDZD`, {
          messaging_type: "RESPONSE",
          recipient: {
            id: "FACEBOOK_USER_ID", // Remplacez par l'ID du destinataire du message
          },
          message: {
            text: userInput,
          },
        });
        
        // Vérifiez si le message a été envoyé avec succès
        if (facebookResponse.status !== 200 || !facebookResponse.data.message_id) {
          throw new Error('Failed to send message to Facebook Messenger');
        }
        


        setPhotoFiles([]);
        setEmoji("");
        setUserInput("");
        setShowEmojiPicker(false);
        setIsSending(false);
      } catch (error) {
        console.log(error);
        setIsSending(false);
      }
    } else {
      alert("Please select the message that you're trying to reply to first!!");
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const emojiPickerContainer = document.querySelector(
        ".emoji-picker-container"
      );
      if (
        emojiPickerContainer &&
        !emojiPickerContainer.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const updateOnlineStatus = async (isActive) => {
    try {
      await setDoc(doc(db, "chatUsers"), { isActive: !isActive });
      console.log("Online status updated successfully!");
    } catch (error) {
      console.error("Error updating online status:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "chatUsers"), (snapshot) => {
      const isActive = snapshot.docs.every((doc) => doc.data().isActive);
      setIsOnline(isActive);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="web-message-page">
      <div className="web-message-container__list">
        <div className="dm-list-header">
          <h1>Chat List</h1>
          <div className="searchbar">
            <input
              type="text"
              placeholder="Search messages... ⚡️"
              onChange={handleSearch}
            />
            <SearchIcon />
          </div>
          <div className="dm-list-container">
            {filteredMessages.map(({ messages }, index) => (
              <div
                onClick={() => setSelectMessage(messages)}
                key={index}
                className="message-list-component"
              >
                <h4>{messages?.messageUserId}</h4>
                <p>{messages.message}</p>
                <p>Today at 08:34</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="web-message-container">

        {/* HEADER */}
        <div className="webmessage-header">
          <div className="user-details">
            <p
              className={`user-profile-picture ${
                isOnline ? "online" : "offline"
              }`}
            >
              J
            </p>
            <p>John Smith</p>
            <p>{isOnline ? "Online" : "Offline"}</p>
          </div>
        </div>

        {/* CHATBOX */}

        <div style={{display: 'flex', flexDirection: 'column', margin: 'auto auto', justifyContent: 'center', flex: 'center', alignContent: 'center', width: '100%'}}>

        <div className="message-wrapper">
          <div className="web-message-container__chatbox" ref={chatboxRef}>
            {allMessages?.map(({ id, messages }) => (
              <div
                key={id}
                className={`${
                  messages?.messageUserId === domain
                  ? "bot-response-inbox"
                  : "user-response-inbox"
                }`}
                >
                {messages?.message}
                {messages?.photoURL && (
                  <img src={messages.photoURL} alt="Uploaded" />
                )}
                <div className="deleteBtn">
                  <p className="truncate">
                    {messages?.messageUserId !== domain &&
                      "USER ID:" + " " + messages?.messageUserId}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="web-message-form">
          <form onSubmit={handleSubmit}>
            <div className="form-inputs">
              <textarea
                name=""
                id="web-message-input"
                cols="30"
                rows="10"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit(e);
                  }
                }}
                placeholder="Type your message..."
                />
             





              <div className="form-options" style={{display: 'flex', flexDirection: 'column-reverse', alignItems: 'center', justifyContent: 'space-between', gap: '25px', width: '100%'}}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '5px', width: '100%'}}>


                {photoFiles.length > 0 && (
                <div className="photo-preview">
                  {photoFiles.map((file, index) => (
                    <div key={index} className="preview-image-container">
                      <img
                        src={file.previewURL}
                        alt="Preview"
                        className="preview-image"
                        />
                      <div
                        className="delete-overlay"
                        onClick={() => handleDeletePhoto(index)}
                        >
                        <DeleteIcon />
                      </div>
                    </div>
                  ))}
                </div>
              )}



                <input
                  type="file"
                  accept="image/*"
                  id="photo-input"
                  onChange={handlePhotoUpload}
                  style={{ display: "none" }}
                  />
                <label htmlFor="photo-input">
                  {photoFiles.length > 0 ? (
                    <AttachFileIcon
                    style={{ color: "green", cursor: "pointer" }}
                    />
                    ) : (
                      <AttachFileIcon
                      style={{ color: "white", cursor: "pointer" }}
                      />
                      )}
                </label>

                

                <MoodIcon
                  className={emoji ? "selected-emoji" : ""}
                  onClick={handleToggleEmojiPicker}
                  style={{ color: "white", cursor: "pointer" }}
                  />

                {showEmojiPicker && (
                  <div className="emoji-picker-container">
                    <EmojiPicker onEmojiClick={handleEmojiSelection} />
                  </div>
                )}

                
                </div>

            <button className="submit-btn" type="submit" disabled={isSending}>
              {isSending ? "Sending..." : "Send message"} <SendIcon />
            </button>
            </div>
              </div>
          </form>
        </div>
                  </div>
      </div>
    </div>
  );
}

export default InstagramDmCompo;